import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Select } from 'antd';

import styles from '../styles';
import Breadcrumbs from '../Components/Breadcrumbs';
import {
  clearUsers,
  getUsers,
  getWeeklyPlans,
  clearWeeklyPlans,
} from '../Actions';
import { get } from '../utils';
import TaskTable from './TaskTable';

const { Option } = Select;

const WeeklyPlan = props => {
  const { classes } = props;

  const dispatch = useDispatch();

  const auth = useSelector(state => state.auth);

  const userId = useMemo(() => get(auth, ['user', 'id'], []), [auth]);

  const users = useSelector(state => state.users);

  useEffect(() => {
    dispatch(getUsers());
    dispatch(getWeeklyPlans(userId));

    return () => {
      dispatch(clearUsers());
      dispatch(clearWeeklyPlans());
    };
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Weekly Plan"
        moduleLink="/weeklyplan"
        subModuleName=""
      />
      <Row className={classes.paddingToContainerContent}>
        <Col className={classes.marginBetweenSelect}>
          <div>User</div>
          <Select
            showSearch
            allowClear
            style={{ width: 200 }}
            placeholder="Select user"
            optionFilterProp="children"
            onChange={value => {
              dispatch(getWeeklyPlans(value));
            }}
          >
            {users.map(user => (
              <Option value={user.id}>{user.name}</Option>
            ))}
          </Select>
        </Col>
      </Row>
      <br />
      <div className={classes.tableStyle}>
        <TaskTable />
      </div>
    </>
  );
};

WeeklyPlan.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WeeklyPlan);
